import { TeamPage } from 'components/teamPage/containers/teamPage';
export const TeamView = TeamPage;
